const passwordValidation = (password) => {
  if (!password) return '入力してください';
  const regex = /^[A-Za-z\d@$#!._]{8,16}$/i;
  if (!regex.test(password)) return '8文字以上16文字以下で半角英数字、記号( ! # $ @ . _)のみで入力してください';
  return '';
};

const nameValidation = (value) => {
  if (!value) return '入力してください';
  return '';
};

const roleValidation = (value) => {
  if (!value || !value.id) return '選択してください';
  return '';
};

class Validation {
  static formValidate = (type, value) => {
    switch (type) {
      case 'password':
        return passwordValidation(value);
      case 'firstName':
      case 'lastName':
      case 'loginId':
        return nameValidation(value);
      case 'role':
        return roleValidation(value);
      default:
        return '';
    }
  };
}

export default Validation;
